import { HTTP as http } from '../../http'

const PREFIX = '/wishlist'

export default {

    insertItemWishList: (data) => {
        return http.post(PREFIX+'/insert', data)
    },

    removeItemWishList: (product_id) => {
        return http.get(PREFIX+'/remove/'+product_id)
    },
    removeAllItemsWishList: () => {
        return http.get(PREFIX+'/removeAll')
    },

    getCountItemsWishlist: () => {
        return http.get(PREFIX+'/getCountItems')
    },

    getListPaginate: (filters) => {
        return http.get(PREFIX+'/getListPaginate?page='+filters.page)
    },

    getListPaginateByUser: (payload) => {
        return http.get(`${PREFIX}/getListPaginateByUser/${payload.userId}?page=${payload.filters}`)
    }

    

}